import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import NoRecruiterPositionsContainer from 'src/components/recruiterPositions/NoRecruiterPositionsContainer';
import RecruiterPositionsContainer from 'src/components/recruiterPositions/RecruiterPositionsContainer';
import Container from 'src/components/shared/Container';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPositionsForRecruiterQuery } from 'src/hooks/position.hooks';
import { sendTrackingEvent } from 'src/utils/gtm';
import { Loader } from 'ui';

const AMPositionsPage = () => {
	const { companyId } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const toast = useToast();
	const { isAccountManagerLoggedIn } = useUserContext();
	const { isFilterLoading, filterApplied, setPositions, setIsLoadingPositions, selectedCompany } =
		useRecommendationsContext();

	const { data: positionsData, isLoading: isPositionsDataLoading } = useGetPositionsForRecruiterQuery(
		isAccountManagerLoggedIn,
		companyId,
		data => setPositions(data.positions ?? []),
	);
	const hasPositions = !!positionsData?.positions?.length || filterApplied || isFilterLoading;

	const handleCreatePosition = () => {
		if (
			selectedCompany?.company?.isBlacklisted ||
			!!(positionsData?.positions?.length ? positionsData?.positions[0]?.position?.company?.isBlacklisted : false)
		) {
			toast({
				title: `Can not create position for blacklisted company`,
				type: 'error',
			});
		} else {
			sendTrackingEvent({
				event: 'recr_dashboard_postajob',
				eventLabel: location.pathname,
			});
			navigate(`/create-position/${companyId}`);
		}
	};

	useEffect(() => {
		if (!companyId || companyId === 'undefined') {
			toast({
				title: `Please create a company first to see positions`,
				type: 'error',
			});
			navigate('/companies');
		}
	}, [companyId]);

	useEffect(() => {
		setIsLoadingPositions(isPositionsDataLoading);
	}, [isPositionsDataLoading]);

	if (!companyId) {
		return (
			<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
				<NoRecruiterPositionsContainer
					title="No Company Found"
					buttonText="Create company"
					onClick={() => navigate('/create-company')}
					description="Please Create a company first to create new positions"
				/>
			</div>
		);
	}

	if (isPositionsDataLoading) {
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);
	}

	return (
		<>
			<Container>
				{hasPositions ? (
					<>
						<RecruiterPositionsContainer
							positionsData={positionsData?.positions ?? []}
							allActivePositionsCount={positionsData?.allActivePositionsCount ?? 0}
							allClosedPositionsCount={positionsData?.allClosedPositionsCount ?? 0}
							handleCreatePosition={handleCreatePosition}
							disableCreate={
								selectedCompany?.company?.isBlacklisted ||
								!!(positionsData?.positions?.length
									? positionsData?.positions[0]?.position?.company?.isBlacklisted
									: false)
							}
						/>
					</>
				) : (
					<>
						<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
							<NoRecruiterPositionsContainer onClick={handleCreatePosition} />
						</div>
					</>
				)}
			</Container>
		</>
	);
};

export default AMPositionsPage;
